// extracted by mini-css-extract-plugin
export default {"sheet":"PhotoSourcePopup_sheet__Zq+-h","title":"PhotoSourcePopup_title__sJrkC","option":"PhotoSourcePopup_option__Rq3wQ","optionLabel":"PhotoSourcePopup_optionLabel__wy4Bf"};